export default class OurPeopleModal {
    constructor() {
        this.settings = {
            $buttons: $(".js-our-people-modal-button"),
            $modals: $(".js-our-people-modal")
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.$buttons) {

            this.settings.$buttons.on('click', (event) => {
                event.preventDefault();

                // Find the clicked button and get the associated data-card-id
                const $button = $(event.currentTarget);
                const cardId = $button.closest('[data-card-id]').data('card-id');

                // Find the corresponding modal based on data-modal-id
                const modal = this.settings.$modals.filter(`[data-modal-id="${cardId}"]`);

                // Show the modal
                if (modal.length) {
                    modal.removeClass('hidden');
                }
            });

        }

        // Close modal when the close button is clicked
        this.settings.$modals.find('.js-our-people-modal-close').on('click', (event) => {
            event.preventDefault();
            const $modal = $(event.currentTarget).closest('.js-our-people-modal');
            $modal.addClass('hidden');
        });
    }
}

new OurPeopleModal();